/* eslint-disable @typescript-eslint/no-explicit-any */
import { assetFragment } from "../fragments";
import {
    ITemplatePageLoader,
    flattenTemplateImageAssets
} from "../get-content-data";

export const CustomersDetailsPageLoader: ITemplatePageLoader = {
    getQueryData: (urlSlug: string, locale: string) => {
        return {
            query: `
                query CustomerDetails($search: ContentPlatformSearchAPIv2Query!) {
                    customerStories(search: $search) {
                        edges {
                            node {
                                title
                                shortTitle
                                storyDescription
                                stats{
                                    stat
                                    statDescription
                                }
                                customerCompany {
                                    name
                                    shortDescription
                                    logo {
                                        ...contentPlatformImageAsset
                                    }
                                    industry {
                                        name
                                    }
                                    region {
                                        name
                                    }
                                    organizationSize {
                                        name
                                    }
                                }
                                numberOfUsers
                                products {
                                    productNameId
                                    url
                                    name
                                    productBlurb
                                    icon {
                                        ...contentPlatformImageAsset
                                    }
                                }
                                advocateQuotes {
                                    advocateName
                                    advocateQuote
                                    advocateJobTitle
                                    advocateHeadshot {
                                        ...contentPlatformImageAsset
                                    }
                                }
                                story {
                                    storyText
                                    bodyAsset {
                                        ...contentPlatformImageAsset
                                    }
                                    embeddedVideoLink
                                }
                            }
                        }
                    }
                }
                ${assetFragment}
            `,
            variables: {
                search: {
                    queries: {
                        first: 1,
                        withLocales: [locale],
                        where: {
                            searchText: {
                                exactlyMatching: {
                                    fieldNamed: "urlSlug",
                                    havingValues: [urlSlug]
                                }
                            }
                        }
                    }
                }
            }
        };
    },

    parseData: (data: any) => {
        return flattenTemplateImageAssets(
            data.customerStories?.edges?.[0]?.node ?? {}
        );
    }
};
